// frontend/src/pages/Terms.tsx
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function Terms() {
  const { t, i18n } = useTranslation("terms");

  useEffect(() => {
    document.title = `${t("title")} – ELANI Energy`;
  }, [i18n.language, t]);

  const sections = [
    "about","disclaimer","entity","accounts","acceptable_use","service","your_content",
    "ip","confidentiality","warranty","liability","indemnity","fees",
    "term","law","changes","imprint"
  ] as const;

  return (
    <main className="mx-auto max-w-4xl px-4 py-10 text-base leading-7 text-slate-800">
      <h1 className="text-3xl font-semibold text-slate-900">{t("title")}</h1>
      <p className="mt-1 text-slate-600">{t("effective_date")}</p>

      {sections.map((k) => (
        <section key={k} className="mt-8">
          <h2 className="text-xl font-medium">{t(`${k}.heading`)}</h2>
          <div className="mt-2 space-y-3">
            {Array.from({ length: 6 }).map((_, i) => {
              const key = `${k}.p${i+1}`;
              const value = t(key);
              if (value === key) return null;
              return <p key={i}>{value}</p>;
            })}
            <ul className="list-disc pl-6 space-y-1">
              {Array.from({ length: 8 }).map((_, i) => {
                const key = `${k}.li${i+1}`;
                const value = t(key);
                if (value === key) return null;
                return <li key={i}>{value}</li>;
              })}
            </ul>
          </div>
        </section>
      ))}
    </main>
  );
}